import React from 'react';
import { Info } from 'lucide-react';
export function DisclaimerSection() {
  return <section className="w-full py-10 px-6 bg-cream/80 border-t border-soft-sage/30" data-id="element-19">
      <div className="max-w-3xl mx-auto" data-id="element-20">
        <div className="flex items-start gap-3 mb-4" data-id="element-21">
          <Info className="w-5 h-5 text-muted flex-shrink-0 mt-0.5" data-id="element-22" />
          <h3 className="text-sm font-bold text-navy uppercase tracking-wider" data-id="element-23">
            Important Disclaimer
          </h3>
        </div>

        <div className="space-y-3 text-sm text-muted leading-relaxed" data-id="element-24">
          <p data-id="element-25">
            <strong className="text-navy/80" data-id="element-26">
              This product is not medical advice.
            </strong>{' '}
            The ER-Ready Mom Binder is an organizational tool designed to help
            you communicate your child's medical history more clearly during
            healthcare visits. It does not diagnose, treat, cure, or prevent any
            disease or medical condition.
          </p>

          <p data-id="element-27">
            Always consult your child's pediatrician, specialist, or qualified
            healthcare provider for medical decisions. Never delay seeking
            professional medical advice because of information organized in this
            binder. In case of a medical emergency, call 911 or your local
            emergency number immediately.
          </p>

          <p data-id="element-28">
            Testimonials reflect individual experiences and are not guaranteed
            outcomes. Results may vary depending on your child's specific
            medical situation and how consistently the system is maintained.
          </p>

          <p data-id="element-29">
            The ER-Ready Mom Binder is a digital product (PDF) created by Better
            By Steps LLC. By purchasing, you agree to our{' '}
            <span className="text-teal font-medium" data-id="element-30">Terms of Service</span> and{' '}
            <span className="text-teal font-medium" data-id="element-31">Privacy Policy</span>.
          </p>
        </div>
      </div>
    </section>;
}